import { toClass } from 'class-converter';
import DeclarationVente from 'mpm-classes/DeclarationVente';
import Components from 'mpm-components';
import Services from 'mpm-services';
import React from 'react';
import { Button, Divider, Icon } from 'semantic-ui-react';
import StepRecap from './sections/StepRecap';

export default ({ selectedDeclarationVenteId, onComplet, setMessage, entities, pays, typesTransformations }) => {
  const [declarationVente, setDeclarationVente] = React.useState(toClass({}, DeclarationVente));
  const [loading, setLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    setIsError(false);
    Services.DeclarationVenteService.findForView(selectedDeclarationVenteId)
      .then((response) => {
        setDeclarationVente(toClass(response.data, DeclarationVente));
        setLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsError(true);
        setLoading(false);
      });
  }, [selectedDeclarationVenteId]);

  return loading ? (
    <Components.MPMLoader message="chargement en cours, veuillez patienter !" hideLogo />
  ) : isError ? (
    <Components.MPMError />
  ) : (
    <>
      {!loading && <StepRecap editMode={false} entities={entities} pays={pays} typesTransformations={typesTransformations} declarationVente={declarationVente} setMessage={(data) => setMessage(data)} setDeclarationVente={(result) => setDeclarationVente(result)} />}
      <Divider />
      <Button icon className="full-width" labelPosition="left" onClick={() => onComplet()} size="tiny">
        <Icon name="arrow left" />
        Retour
      </Button>
    </>
  );
};
